import successSound from "../assets/sounds/success.mp3"
import errorSound from "../assets/sounds/error.mp3"
import confirmSound from "../assets/sounds/confirm.mp3"
import addressChangedSound from "../assets/sounds/addressChanged.mp3"

const Sounds = {
  error: () => {
    new Audio(errorSound).play()
  },
  warning: () => {
    new Audio(confirmSound).play()
  },
  success: () => {
    new Audio(successSound).play()
  },
  addressChangedSound: () => {
    new Audio(addressChangedSound).play()
  },
}

export default Sounds
